<template>
  <v-dialog v-model="dialog" @keydown.esc="close" :max-width="props.width">
    <v-card>
      <v-card-title>
        <v-toolbar-title>
          <span class="headline">{{ props.title }}</span>
        </v-toolbar-title>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text v-show="!!props.message">
        <v-flex xs12>
          <p>{{ props.message }}</p>
        </v-flex>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" depressed dark @click.native="close">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      props: {
        title: null,
        message: null,
        width: 380
      }
    }
  },

  methods: {
    open (props) {
      this.dialog = true
      this.props = Object.assign(this.props, props)
    },

    close () {
      this.dialog = false
    }
  }
}
</script>
